import { css } from '@emotion/core'

import * as MQ from 'styles/media-queries'
import { measures } from 'styles/variables'

const { unit } = measures

export const phoneSpace = css`
  ${MQ.PHONES} {
    margin-bottom: ${unit * 2}px;
  }
`
